<input type="file" [accept]="tipoArquivoPermitido" class="file-input" (change)="onFileSelected($event)" #fileUpload />

<div class="file-upload">

    <div class="file-upload-fileName">{{fileName || "Selecione um arquivo."}}</div>

    <button class="file-upload-button" (click)="fileUpload.click()">
        Anexar
    </button>
</div>